"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ExtraFiltersEnum_1 = __importDefault(require("@react/web/Listing/Filter/ExtraFiltersEnum"));
const FilterByFormData_1 = __importDefault(require("@react/web/Listing/Filter/FilterByFormData"));
const WinterTiresFilterEnum_1 = __importDefault(require("@react/web/Listing/Filter/WinterTiresFilterEnum"));
const FilterStateKeysEnum_1 = __importDefault(require("@react/web/Listing/Filter/FilterStateKeysEnum"));
class FilterCountUpdater {
    static updateFilterCount(filterFormData, listingOffersList, isMergedOffer) {
        if (isMergedOffer === false) {
            this.updateMakeFilterCount(filterFormData, listingOffersList);
            this.updateModelFilterCount(filterFormData, listingOffersList);
            this.updateBodyTypeFilterCount(filterFormData, listingOffersList);
        }
        this.updateMileageFilterCount(filterFormData, listingOffersList);
        this.updateInquiryTypeFilterCount(filterFormData, listingOffersList);
        this.updateContractLengthFilterCount(filterFormData, listingOffersList);
        this.updateFuelTypeFilterCount(filterFormData, listingOffersList);
        this.updateGearChangingFilterCount(filterFormData, listingOffersList);
        this.updateAllWheelDriveFilterCount(filterFormData, listingOffersList);
        this.updateExtraLabelFilterCount(filterFormData, listingOffersList);
        this.updateWinterTiresFilterCount(filterFormData, listingOffersList);
        this.updateEquipmentFilterCount(filterFormData, listingOffersList);
        this.updateAvailabilityFilterCount(filterFormData, listingOffersList);
    }
    static getSimpleOffersCount(carListingOffers) {
        let count = 0;
        carListingOffers.forEach((offer) => {
            count += offer.simpleOfferList.getCount();
        });
        return count;
    }
    static getFilteredOffers(filterFormData, carListingOffers, filterKey) {
        let offers = FilterByFormData_1.default.createListingOffersCopy(carListingOffers);
        if (filterKey !== FilterStateKeysEnum_1.default.inquiryType) {
            offers = FilterByFormData_1.default.filterByInquiryType(filterFormData, offers);
        }
        if (filterKey !== FilterStateKeysEnum_1.default.contractLength) {
            offers = FilterByFormData_1.default.filterByContractLength(filterFormData, offers);
        }
        if (filterKey !== FilterStateKeysEnum_1.default.body) {
            offers = FilterByFormData_1.default.filterByBodyType(filterFormData, offers);
        }
        if (filterKey !== FilterStateKeysEnum_1.default.mileage) {
            offers = FilterByFormData_1.default.filterByMileage(filterFormData, offers);
        }
        if (filterKey !== FilterStateKeysEnum_1.default.fuel) {
            offers = FilterByFormData_1.default.filterByFuelType(filterFormData, offers);
        }
        if (filterKey !== ExtraFiltersEnum_1.default.automat) {
            offers = FilterByFormData_1.default.filterByGearChanging(filterFormData, offers);
        }
        if (filterKey !== ExtraFiltersEnum_1.default.allWheelDrive) {
            offers = FilterByFormData_1.default.filterByAllWheelDrive(filterFormData, offers);
        }
        if (filterKey !== ExtraFiltersEnum_1.default.extraLabel) {
            offers = FilterByFormData_1.default.filterByExtraLabel(filterFormData, offers);
        }
        if (filterKey !== FilterStateKeysEnum_1.default.winterTires) {
            offers = FilterByFormData_1.default.filterByWinterTires(filterFormData, offers);
        }
        if (filterKey !== FilterStateKeysEnum_1.default.availability) {
            offers = FilterByFormData_1.default.filterByAvailability(filterFormData, offers);
        }
        offers = FilterByFormData_1.default.filterByEquipment(filterFormData, offers);
        if (filterKey === FilterStateKeysEnum_1.default.make || filterKey === FilterStateKeysEnum_1.default.model) {
            return offers;
        }
        offers = FilterByFormData_1.default.filterByMake(filterFormData, offers);
        offers = FilterByFormData_1.default.filterByModel(filterFormData, offers);
        return offers;
    }
    static updateCountByCarListingOffers(filteredOffers, item, callback) {
        const carListingOffers = FilterByFormData_1.default.filterCarListingOffers(filteredOffers, callback);
        item.offerCount = this.getSimpleOffersCount(carListingOffers);
    }
    static updateCountBySimpleOffers(filteredOffers, item, callback) {
        let carListingOffers = FilterByFormData_1.default.createListingOffersCopy(filteredOffers);
        carListingOffers = FilterByFormData_1.default.filterSimpleOffers(carListingOffers, callback);
        item.offerCount = this.getSimpleOffersCount(carListingOffers);
    }
    static updateCountByPriceOffers(filteredOffers, item, callback) {
        let carListingOffers = FilterByFormData_1.default.createListingOffersCopy(filteredOffers);
        carListingOffers = FilterByFormData_1.default.filterPriceOffers(carListingOffers, callback);
        item.offerCount = this.getSimpleOffersCount(carListingOffers);
    }
    static updateMakeFilterCount(filterFormData, listingOffersList) {
        const filteredOffers = this.getFilteredOffers(filterFormData, listingOffersList.listingOffers, FilterStateKeysEnum_1.default.make);
        filterFormData.make.forEach((item) => {
            this.updateCountByCarListingOffers(filteredOffers, item, (carListingOffer) => item.value === carListingOffer.makeSlug);
        });
    }
    static updateModelFilterCount(filterFormData, listingOffersList) {
        const filteredOffers = this.getFilteredOffers(filterFormData, listingOffersList.listingOffers, FilterStateKeysEnum_1.default.model);
        filterFormData.model.forEach((item) => {
            this.updateCountByCarListingOffers(filteredOffers, item, (carListingOffer) => item.value === carListingOffer.modelSlug);
        });
    }
    static updateBodyTypeFilterCount(filterFormData, listingOffersList) {
        const filteredOffers = this.getFilteredOffers(filterFormData, listingOffersList.listingOffers, FilterStateKeysEnum_1.default.body);
        filterFormData.body.forEach((item) => {
            this.updateCountByCarListingOffers(filteredOffers, item, (carListingOffer) => item.value === carListingOffer.bodyType);
        });
    }
    static updateMileageFilterCount(filterFormData, listingOffersList) {
        const filteredOffers = this.getFilteredOffers(filterFormData, listingOffersList.listingOffers, FilterStateKeysEnum_1.default.mileage);
        filterFormData.mileage.forEach((item) => {
            this.updateCountByPriceOffers(filteredOffers, item, (priceOffer) => priceOffer.mileageYearly >= Number(item.value));
        });
    }
    static updateInquiryTypeFilterCount(filterFormData, listingOffersList) {
        const filteredOffers = this.getFilteredOffers(filterFormData, listingOffersList.listingOffers, FilterStateKeysEnum_1.default.inquiryType);
        filterFormData.inquiryType.forEach((item) => {
            this.updateCountByPriceOffers(filteredOffers, item, (priceOffer) => priceOffer.assignedInquiryType === item.value);
        });
    }
    static updateContractLengthFilterCount(filterFormData, listingOffersList) {
        const filteredOffers = this.getFilteredOffers(filterFormData, listingOffersList.listingOffers, FilterStateKeysEnum_1.default.contractLength);
        filterFormData.contractLength.forEach((item) => {
            this.updateCountByPriceOffers(filteredOffers, item, (priceOffer) => {
                if (priceOffer.contractLengths === null) {
                    return false;
                }
                return priceOffer.contractLengths.some((contractLength) => String(contractLength.value) === item.value);
            });
        });
    }
    static updateFuelTypeFilterCount(filterFormData, listingOffersList) {
        const filteredOffers = this.getFilteredOffers(filterFormData, listingOffersList.listingOffers, FilterStateKeysEnum_1.default.fuel);
        filterFormData.fuel.forEach((item) => {
            this.updateCountBySimpleOffers(filteredOffers, item, (simpleOffer) => item.label === simpleOffer.powertrain.filterFuelType);
        });
    }
    static updateGearChangingFilterCount(filterFormData, listingOffersList) {
        const filteredOffers = this.getFilteredOffers(filterFormData, listingOffersList.listingOffers, ExtraFiltersEnum_1.default.automat);
        filterFormData.extra.forEach((item) => {
            if (item.value !== ExtraFiltersEnum_1.default.automat) {
                return;
            }
            this.updateCountBySimpleOffers(filteredOffers, item, (simpleOffer) => item.value === simpleOffer.powertrain.gearChanging.toLowerCase());
        });
    }
    static updateAllWheelDriveFilterCount(filterFormData, listingOffersList) {
        const filteredOffers = this.getFilteredOffers(filterFormData, listingOffersList.listingOffers, ExtraFiltersEnum_1.default.allWheelDrive);
        filterFormData.extra.forEach((item) => {
            if (item.value !== ExtraFiltersEnum_1.default.allWheelDrive) {
                return;
            }
            this.updateCountBySimpleOffers(filteredOffers, item, (simpleOffer) => simpleOffer.powertrain.isFourWheelDrive);
        });
    }
    static updateExtraLabelFilterCount(filterFormData, listingOffersList) {
        const filteredOffers = this.getFilteredOffers(filterFormData, listingOffersList.listingOffers, ExtraFiltersEnum_1.default.extraLabel);
        filterFormData.extra.forEach((item) => {
            if (item.value !== ExtraFiltersEnum_1.default.extraLabel) {
                return;
            }
            this.updateCountBySimpleOffers(filteredOffers, item, (simpleOffer) => simpleOffer.extraLabelList.length > 0);
        });
    }
    static updateWinterTiresFilterCount(filterFormData, listingOffersList) {
        const filteredOffers = this.getFilteredOffers(filterFormData, listingOffersList.listingOffers, FilterStateKeysEnum_1.default.winterTires);
        filterFormData.winterTires.forEach((item) => {
            this.updateCountBySimpleOffers(filteredOffers, item, (simpleOffer) => simpleOffer.hasWinterTires === (item.value === WinterTiresFilterEnum_1.default.included));
        });
    }
    static updateEquipmentFilterCount(filterFormData, listingOffersList) {
        const filteredOffers = this.getFilteredOffers(filterFormData, listingOffersList.listingOffers, FilterStateKeysEnum_1.default.equipment);
        filterFormData.equipment.forEach((item) => {
            this.updateCountBySimpleOffers(filteredOffers, item, (simpleOffer) => item.id === null || simpleOffer.equipments.includes(item.id));
        });
    }
    static updateAvailabilityFilterCount(filterFormData, listingOffersList) {
        const filteredOffers = this.getFilteredOffers(filterFormData, listingOffersList.listingOffers, FilterStateKeysEnum_1.default.availability);
        filterFormData.availability.forEach((item) => {
            this.updateCountBySimpleOffers(filteredOffers, item, (simpleOffer) => item.label === simpleOffer.availabilityDescription);
        });
    }
}
exports.default = FilterCountUpdater;
